import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    map: ["T_PackagingPrint_New_A.jpg", {
    }],
    roughnessMap: ["T_CorrugatedCardboard_R.jpg", {
        repeat: new Vector2(10, 10)
    }],
    normalMap: ["T_CorrugatedCardboard_N.jpg", {
        repeat: new Vector2(10, 10)
    }],
    aoMap: ["T_Packaging_New_AO.jpg", {
        channel: 1,
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#FFFFFF"),
        metalness: 0,
        roughness: 1,
        normalScale: new Vector2(0.125, 0.125),
        envMapIntensity: 1,
        aoMapIntensity: 2,
    });
}